//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import openURL from 'quasar/src/utils/open-url.js';

export default {
  name: 'MyLayout',

  data () {
    return {
      leftDrawerOpen: true
    }
  },
  methods: {
    openURL,
    logout () {
      localStorage.removeItem('report_trade_checkbook')
      this.$router.push({ path: '/login' })
    },
    goToPromotions () {
      window.location = window.location.origin + '/promotions/new/'
    },
    goToCalculator () {
      window.location = window.location.origin + '/calculator'
    },
    goToHome () {
      window.location = window.location.origin
    }
  }
}

